<script lang="ts">
  import discordLogo from 'branding/discord.png?enhanced'
  import xLogo from 'branding/twitter.png?enhanced'
  import telegramLogo from 'branding/telegram.png?enhanced'
  import forumLogo from 'branding/forum.png?enhanced'
  import ColorfulCircleSvg from '../../components/SVGs/ColorfulCircleSVG.svelte'
  import ButaneImage from '$lib/components/ButaneImage.svelte'
</script>

<div class="relative mb-[15vw] flex w-fit flex-col sm:mx-auto lg-desktop:mb-[10rem]">
  <ColorfulCircleSvg svgStyles="mx-auto h-[100%] w-[95vw] sm:w-[600px] sm-desktop:w-[800px]" />
  <div class="absolute inset-0 flex items-center justify-center">
    <div
      class="flex h-[60%] w-[60vw] items-center justify-center rounded-full border-[0.46px] border-[#e3e5ea] bg-black sm:h-[400px] sm:w-[400px]"
    >
      <ButaneImage
        src="logo_4.png"
        width={200}
        height={200}
        alt="butane logo"
        class="w-[30vw] scale-150 sm:h-[200px] sm:w-[200px]"
      />
    </div>
  </div>

  <a
    class="absolute top-0 flex h-[25%] w-[25vw] items-center justify-center rounded-full border-[0.46px] border-[#272D37] bg-black sm:h-[full] sm:w-[150px] sm-desktop:w-[200px]"
    href="https://x.com/butaneprotocol"
  >
    <ButaneImage src="twitter.png" width={100} height={100} alt="x" class="w-[15vw] sm:h-[100px] sm:w-[100px]" />
  </a>
  <a
    class="absolute right-0 top-0 flex h-[25%] w-[25vw] items-center justify-center rounded-full border-[0.46px] border-[#272D37] bg-black sm:h-[full] sm:w-[150px] sm-desktop:w-[200px]"
    href="https://discord.gg/pxJah7qnnu"
  >
    <ButaneImage src="discord.png" width={100} height={100} alt="discord" class="w-[15vw] sm:h-[100px] sm:w-[100px]" />
  </a>
  <a
    class="absolute bottom-0 flex h-[25%] w-[25vw] items-center justify-center rounded-full border-[0.46px] border-[#272D37] bg-black sm:h-[full] sm:w-[150px] sm-desktop:w-[200px]"
    href="https://t.me/butaneprotocol"
  >
    <ButaneImage
      src="telegram.png"
      width={100}
      height={100}
      alt="telegram"
      class="w-[15vw] sm:h-[100px] sm:w-[100px]"
    />
  </a>

  <a
    class="absolute bottom-0 right-0 flex h-[25%] w-[25vw] items-center justify-center rounded-full border-[0.46px] border-[#272D37] bg-black sm:h-[full] sm:w-[150px] sm-desktop:w-[200px]"
    href="https://forum.butane.dev/"
  >
    <ButaneImage src="forum.png" width={100} height={100} alt="forum" class="w-[15vw] sm:h-[100px] sm:w-[100px]" />
  </a>
</div>
